<template>
  <v-menu bottom rounded offset-y>
    <template v-slot:activator="{ on }">
      <v-btn color="grey" elevation="0" v-on="on" icon>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list dense>
        <span v-for="(option, index) in options(appointment)" :key="index">
          <v-list-item
            @click="action(option)"
            v-if="option.show"
            link
          >
            <v-icon class="mr-3 grey--text text--lighten-1" style="transform: scale(0.85); opacity: 0.75">
              {{ option.icon }}
            </v-icon>
            <span class="body-2">
              {{ option.title }}
            </span>
          </v-list-item>
        </span>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { options } from '@/components/appointment/menuAdminAppointment'

export default {
  name: 'MenuAppointment',

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  methods: {
    ...mapActions(['openModal', 'fetchAppointment']),
    ...mapMutations(['setIsAppointmentLoading']),

    emitModalAndAppointment(appointment, modal, fetchAppointment, confirmModal = false) {
      if (confirmModal) this.fetchConfirmAppointmentData(appointment?.id)

      this.openModal(modal)

      if (fetchAppointment) {
        this.setIsAppointmentLoading(true)
        this.fetchAppointment(appointment?.id).finally(() => this.setIsAppointmentLoading(false))
      }
    },

    setMenuOptions(appointment) {
      this.menuOptions = this.options(appointment)
    },

    action(option) {
      if (typeof option.action === 'function') {
        option.action()
        return
      }

      if (option.type === 'dispute') {
        this.$store.commit('setIsDisputeDrawerOpen', true)
        this.emitModalAndAppointment(this.appointment, option.modal, option.fetchAppointment)
        return
      }

      this.emitModalAndAppointment(this.appointment, option.modal, option.fetchAppointment)
    },
  },

  data() {
    return {
      options: options,
      menuOptions: [],
    }
  },
}
</script>
